import axios from 'axios'

//本地测试
// axios.defaults.baseURL = 'http://192.168.1.207:6410/'
axios.defaults.baseURL = 'https://www.chinahaohe.com/haohe/'
axios.defaults.timeout = 15 * 1000;

export default axios